import React, {useEffect, useState} from 'react';

export default ({
  item,
  calculatePositionOfStickyHeaders,
  config,
  setUpdating,
  setSelectedItem,
  createUpdateItem,
  getItems,
  activeName,
  unActiveName,
  team,
  index,
  unEditable,
}) => {
  const [checked, setChecked] = useState(item.isActive);

  useEffect(() => {
    setChecked(item.isActive);
  }, [item.isActive]);

  const updateStatusDB = (value) => {
    let updatedItem;
    if (unEditable) {
      updatedItem = {
        isActive: value,
      };
      createUpdateItem(updatedItem, item._id);
    } else {
      updatedItem = {
        teamId: item.teamId || team._id,
        userId: item._id,
        isActive: value,
      };
      createUpdateItem(updatedItem);
    }
    setUpdating(true);
    setTimeout(() => {
      getItems();
      setUpdating(false);
    }, 1000);
  };

  const onChange = (event) => {
    const result = event.target.checked;
    setChecked(result);
    if (item._id !== 'new_user') {
      updateStatusDB(result);
    } else {
      setSelectedItem((value) => ({
        ...value,
        isActive: result,
      }));
    }
  };

  return (
    <td
      className={`text-right ${index === 0 ? 'first-cell' : ''}`}
      style={calculatePositionOfStickyHeaders(config)}
    >
      <span className="mr-2">{checked ? activeName : unActiveName}</span>
      <label className="switch m-0 mr-3">
        <input type="checkbox" checked={checked} onChange={onChange}></input>
        <span className="slider round"></span>
      </label>
    </td>
  );
};
